import { ContactInfo, ContactType } from "../../../home/models/ContactInfo";

type InvoicePrintContactProps = {
    contacts: ContactInfo[];
}

export default function InvoicePrintContactView({ contacts }: InvoicePrintContactProps) {
    return <div className="center">
        <div className="font-title">Contacts</div>

        {contacts.map((contact: ContactInfo, index: number) => {
            return <div>
                {(contact.type === ContactType.phone || contact.type === ContactType.email) && <>
                    <div className="pt-10">{contact.name} : {contact.account1 ?? ""}</div>
                </>}
            </div>;
        })}
    </div>
}